var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"right","width":"400","trigger":"click"}},[_c('div',{staticClass:"referenceContent",domProps:{"innerHTML":_vm._s(_vm.priceDescribe)}}),_vm._v(" "),_c('span',{staticClass:"reference",attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-warning"}),_vm._v(" 说明\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }